import { useEffect, useState } from 'react'
import { ChartWidget } from '../Watchlist'
import { useWFHMessages } from '../../hooks';
import { getDecryptLocalStorage, sendDataToChart } from '../../utils/global_functions';
import { TL_INDEX, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { connectSocket, sendTouchlineRequest } from '../../apis/web_socket';

const PopOutChart = () => {
  let { chartUrl, data: scripOverviewData } = JSON.parse(getDecryptLocalStorage('OVERVIEW_CHART_DATA'));
  const [data, setData] = useState(null);
  useEffect(() => {
    connectSocket();
  }, []);
  useEffect(() => {
    setTimeout(() => {
      sendTouchlineRequest([{ exchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }]);
    }, 3000);
  }, [scripOverviewData]);
  useWFHMessages('touchline', (e) => {
    if (scripOverviewData?.length) {
      if (e.detail[TL_INDEX.TOKEN] === scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN]) {
        sendDataToChart(e.detail, scripOverviewData);
        setData(e.detail);
      }
    }
  });

  return (
    <>
      <ChartWidget chartUrl={chartUrl} isPopOut={true} />
    </>
  );
};

export default PopOutChart;